"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoticesWrapper = void 0;
var Notices_1 = __importDefault(require("@features/ItemCommon/components/Notices/Notices"));
var react_1 = __importStar(require("react"));
function NoticesWrapper(_a) {
    var _b;
    var job = _a.job, showBoundingBox = _a.showBoundingBox, setShowBoundingBox = _a.setShowBoundingBox;
    var _c = __read((0, react_1.useState)(), 2), generatedNotices = _c[0], setGeneratedNotices = _c[1];
    (0, react_1.useEffect)(function () {
        var _a;
        var transformedGeneratedNotices = (_a = job.generatedNotices) === null || _a === void 0 ? void 0 : _a.map(function (notice) { return (__assign(__assign({}, notice), { showBoundingBoxes: false, lockInShowBoundingBoxes: false })); });
        setGeneratedNotices(transformedGeneratedNotices);
    }, [(_b = job.ad) === null || _b === void 0 ? void 0 : _b.id]);
    var updateGeneratedNoticesArray = function (id, showBoundingBoxes, lockInShowBoundingBoxes) {
        var newGeneratedNotices = generatedNotices === null || generatedNotices === void 0 ? void 0 : generatedNotices.map(function (notice) {
            if (notice.id === id) {
                return __assign(__assign({}, notice), { showBoundingBoxes: showBoundingBoxes, lockInShowBoundingBoxes: lockInShowBoundingBoxes });
            }
            return notice;
        });
        setGeneratedNotices(newGeneratedNotices);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null, ((job.notices && (job === null || job === void 0 ? void 0 : job.notices.length) > 0) || (job.generatedNotices && (job === null || job === void 0 ? void 0 : job.generatedNotices.length) > 0)) && (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Notices_1.default, { notices: job.notices, generatedNotices: generatedNotices, triggerNoticeBoundingBoxes: function (id, newNotice) {
                var _a;
                updateGeneratedNoticesArray(id, newNotice.showBoundingBoxes, newNotice.lockInShowBoundingBoxes);
                setShowBoundingBox(__assign(__assign({}, showBoundingBox), (_a = {}, _a[id] = newNotice.showBoundingBoxes, _a)));
            } })))));
}
exports.NoticesWrapper = NoticesWrapper;
